goog.provide('el8.appchart.visitNote.alertFeed');

goog.require('el8.uiwidget.Feed');
goog.require('el8.template.appchart.visitNote.alertFeed');
goog.require('el8.template.render.visitNote.alertFeed');
goog.require('el8.data.decisionSupports');
goog.require('el8.ptdata.fetch');
goog.require('el8.util.feed');
goog.require('el8.uiwidget.collapsible');
goog.require('el8.appchart.dialog.addEditImmunization');
goog.require('el8.appchart.dialog.addEditImmunizationNew');
goog.require('el8.appchart.visitNote.cdsDialog');
goog.require('el8.appchart.visitNote.cdsDetailDialog');
goog.require('el8.util.amplitude.helpers');

/**
 * This file controls the yellow feed of action items at the top of a visit note.
 * As of 10/2015, these are only used for CDSs (Clinical Decision Support).
 */
el8.appchart.visitNote.alertFeed = null;

el8.appchart.visitNote.initAlertFeed = function(noteFormObj, container) {

    if (el8.appchart.visitNote.alertFeed) { return; }

    el8.appchart.visitNote.alertFeed = (new el8.uiwidget.Feed({
        container: container,
        name: 'visit-note-alert',
        rendererFn: function(item, feedItemId) {
            if (item.getModelClass() !== 'DecisionSupport') { return ''; }
            return function(item, feedItemId) {
                return el8.template.render.visitNote.alertFeed.cqm({
                    item: item.asSoyMap(),
                    feedItemId: feedItemId,
                    showCdsDetails: el8.data.currUser.isCdsDisplaySupDiag(),
                    additionalCareGapContext: el8.data.decisionSupports.getAdditionalCareGapContext(item.getNqfCode())
                });
            };
        },
        skeletonFn: el8.template.appchart.visitNote.alertFeed.skeleton,
        fetchFn: function(arg) { // Assume these are all DecisionSupport's
            if (this.seenDecisionSupportIds === undefined) {
                this.seenDecisionSupportIds = {};
            }
            var that = this;
            function trackCdsAvailable(decisionSupport) {
                var id = decisionSupport.getId();
                if (that.seenDecisionSupportIds[id]) { return; }
                that.seenDecisionSupportIds[id] = true;
            }

            var decisionSupports = null;
            if (arg instanceof Array) {
                decisionSupports = arg.map(function(a) {
                    var decisionSupport = el8.data.decisionSupports.getById(a.id);
                    trackCdsAvailable(decisionSupport);
                    return decisionSupport;
                });
            } else {
                decisionSupports = el8.data.decisionSupports.getById(arg.id);
                trackCdsAvailable(decisionSupports);
            }
            return decisionSupports;
        },
        clickTriggerMap: {
            '.note-alert-item-trigger': function($target) {
                var $alertItem = $target.closest('.alert-item');
                var id = $alertItem.data('id');
                var item = el8.data.decisionSupports.getById(id);
                el8.appchart.visitNote.cdsDetailDialog.show({
                    nqfCode: item.getNqfCode()
                });
            },
            '.resolve-trigger': function($target) {
                var $alertItem = $target.closest('.alert-item');
                var id = $alertItem.data('id');
                var item = el8.data.decisionSupports.getById(id);
                var _resolveCallbackFn = getResolveCdsItemFn({
                    noteFormObj: noteFormObj,
                    alertItem: $alertItem,
                    item: item,
                    statusStr: 'addressed'
                });

                // Sometimes we have only one option but we still want to prompt the user,
                // because the action required is something we need them to see and approve
                // (e.g., counsel patient about X) or because we can't take that action for them
                // (e.g., record BMI). But other times, we just take the single action when
                 // the user clicks "Address" (e.g., open the dialog to record smoking status).
                 // `skipOptionPrompt` tells us which of those two situations we're in.
                if (item.isSkipOptionPrompt() && item.getResponseOptions().length === 1) {
                    var response = item.getResponseOptions()[0];
                    response.actOn(noteFormObj);
                    _resolveCallbackFn();
                } else {
                    el8.appchart.visitNote.cdsDialog.show({
                        item: item,
                        noteFormObj: noteFormObj,
                        resolveCallbackFn: _resolveCallbackFn
                    });
                }
                el8.util.amplitude.logEvent('respond to CDS alert', {
                  'CDS response': 'Address',
                  'CDS measure code': item.getNqfCode(),
                  'document id': el8.appchart.visitNote.main.getNoteId()
                });
            },
            '.dismiss-trigger': function($target) {
                var $alertItem = $target.closest('.alert-item');
                var id = $alertItem.data('id');
                var item = el8.data.decisionSupports.getById(id);
                getResolveCdsItemFn({
                    noteFormObj: noteFormObj,
                    alertItem: $alertItem,
                    item: item,
                    statusStr: 'dismissed'
                })();
                el8.util.amplitude.logEvent('respond to CDS alert', {
                  'CDS response': 'Dismiss',
                  'CDS measure code': item.getNqfCode(),
                  'document id': el8.appchart.visitNote.main.getNoteId()
                });
            },
            '.additional-context-trigger': function($target) {
                $target.toggleClass('el8CDSActionAdditionalCareGapContextCollapsed')
            }
        }
    })).init();

    el8.appchart.visitNote.alertFeed.resolveCdsItem = function(item, statusStr, callbackFn) {
        var $alertItem = $('.alert-item[data-id="'+item.getId()+'"]', container);
        if ($alertItem.length) {
            getResolveCdsItemFn({
                noteFormObj: noteFormObj,
                alertItem: $alertItem,
                item: item,
                statusStr: statusStr,
                callbackFn: callbackFn
            })();
        }
    };

    function getResolveCdsItemFn(spec) {
        spec = spec || {};
        var noteFormObj = spec.noteFormObj;
        var $alertItem = spec.alertItem;
        var item = spec.item;
        var id = item.getId();
        var statusStr = spec.statusStr;
        var callbackFn = spec.callbackFn;

        return function() {
            if (!item.getNqfCode()) { return; }
            var code = item.getNqfCode();
            $.el8_ajax({
                type: 'POST',
                data: {'data': JSON.stringify({'alert_text': item.getPromptLabel(), 'status': statusStr})},
                url: el8.service.urls.get('updateVisitNoteAlert', [noteFormObj.getNoteId(), code]),
                success: function(data) {
                    if (!noteFormObj || !noteFormObj.getNote()) { return; }
                    noteFormObj.getNote().getAlerts().create(data);
                    removeAlertItem($alertItem, id);
                    if (callbackFn) { callbackFn(); }
                }
            });
        };
    }

    function removeAlertItem($elt, id) {
        if (!el8.appchart.visitNote.alertFeed) { return; }
        el8.appchart.visitNote.alertFeed.remove(id, 400);
        if (el8.appchart.visitNote.alertFeed.isEmpty()) {
            el8.appchart.visitNote.alertFeed.hide(400);
        }
    }

    el8.uiwidget.collapsible({
        container: $('#visit-note-alert-feed-list', container),
        statusElt: $('.visit-note-cds-status', container),
        triggerElt: $('.visit-note-cds-trigger', container),
        collapseFn: function() {
            $('.visit-note-cds-trigger', container).removeClass('el8HeaderNoBorderMb5')
                .addClass('el8HeaderNoBorder');
        },
        expandFn: function() {
            $('.visit-note-cds-trigger', container).addClass('el8HeaderNoBorderMb5')
                .removeClass('el8HeaderNoBorder');
        },
        isCollapsed: false
    });

    $(container).on('click', '.visit-note-cds-settings-trigger',  function (e) {
        if (el8.data.currUser.isPhysician()) {
            window.open('/settings/appprefs/', '_blank');
        } else {
            window.open('/settings/staff-display/', '_blank');
        }
        return false;
    });

};

el8.appchart.visitNote.resetAlertFeed = function(container) {
    if (!el8.appchart.visitNote.alertFeed) { return; }
    el8.appchart.visitNote.alertFeed.resetRender();
    el8.appchart.visitNote.alertFeed = null;
};

el8.appchart.visitNote.refreshAlertFeed = function(note, async) {
    if (!el8.appchart.visitNote.alertFeed) { return; }
    var renderingContext = {
        context: 'visitnote',
        relatedObject: note
    };

    el8.data.decisionSupports.getFeedIndex(function(index) {
        if (!el8.appchart.visitNote.alertFeed) { return; }
        el8.appchart.visitNote.alertFeed.resetRender();
        el8.appchart.visitNote.alertFeed.loadIndex(index);
        el8.appchart.visitNote.alertFeed.display();
    }, renderingContext, async);
};
